import cAuthorizationResourceLink from './AuthorizationResourceLink'
export const AuthorizationResourceLink = cAuthorizationResourceLink
